import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

import LINKS from 'constants/links';

const TopbarBottomLeftDefaultNav = dynamic(() =>
  import('./TopbarBottomLeftDefaultNav')
);
const TopbarBottomLeftCouponsNav = dynamic(() =>
  import('./TopbarBottomLeftCouponsNav')
);
const TopbarBottomLeftForumNav = dynamic(() =>
  import('./TopbarBottomLeftForumNav')
);

const TopbarBottomLeftNav = ({
  commentsCount,
  currInitialPath,
  gaEventCategory,
  onLastCommentsClick,
}) => {
  const navsByPage = useMemo(() => {
    const sharedProps = {
      commentsCount,
      gaEventCategory,
      onLastCommentsClick,
    };

    return {
      [LINKS.COUPONS]: (
        <TopbarBottomLeftCouponsNav gaEventCategory={gaEventCategory} />
      ),
      [LINKS.FORUM]: <TopbarBottomLeftForumNav {...sharedProps} />,
      default: <TopbarBottomLeftDefaultNav {...sharedProps} />,
    };
  }, [commentsCount, onLastCommentsClick]);

  return navsByPage[currInitialPath] ?? navsByPage.default;
};

TopbarBottomLeftNav.defaultProps = {
  commentsCount: null,
  currInitialPath: null,
};

TopbarBottomLeftNav.propTypes = {
  commentsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  currInitialPath: PropTypes.string,
  gaEventCategory: PropTypes.string.isRequired,
  onLastCommentsClick: PropTypes.func.isRequired,
};

export default TopbarBottomLeftNav;
